import type { UiSchema } from '@/shared/ui/SchemaForm';

const TOOL_UI_SCHEMAS: Record<string, UiSchema> = {
  get_documents_by_file_name: {
    knowledgeBaseId: { 'ui:widget': 'kbSelect' },
  },
  query_knowledge_base_tool: {
    knowledgeBaseIds: { 'ui:widget': 'kbMultiSelect' }, // Multi-KB support
    knowledgeBaseId: { 'ui:widget': 'kbSelect' }, // Legacy single KB
  },
  list_kb_files: {
    knowledgeBaseId: { 'ui:widget': 'kbSelect' },
  },
};

/**
 * Field-name-level UI schema mapping. Some field names always need a specific widget
 * regardless of which tool provides them. Used by the merged agent config form.
 */
const FIELD_UI_SCHEMAS: Record<string, UiSchema> = {
  knowledgeBaseIds: { 'ui:widget': 'kbMultiSelect' }, // Multi-KB support
  knowledgeBaseId: { 'ui:widget': 'kbSelect' }, // Legacy single KB
  templates: { additionalProperties: { 'ui:widget': 'htmlTemplateEditor' } },
};

export function getToolUiSchema(toolId: string): UiSchema {
  return TOOL_UI_SCHEMAS[toolId] ?? {};
}

export function getFieldUiSchemas(): Record<string, UiSchema> {
  return FIELD_UI_SCHEMAS;
}
